"use strict";
var _a, _b, _c, _d, _e, _f, _g;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GRADIENT = exports.GREY = exports.GREY_HUE = exports.UTILITY = exports.THEME = exports.PURPLE = exports.YELLOW = exports.ORANGE = exports.GREEN = exports.RED = exports.BLUE = exports.calcGrey = exports.calcGradient = void 0;
var calc_gradient_1 = require("./calc-gradient");
Object.defineProperty(exports, "calcGradient", { enumerable: true, get: function () { return calc_gradient_1.calcGradient; } });
var calc_grey_1 = require("./calc-grey");
Object.defineProperty(exports, "calcGrey", { enumerable: true, get: function () { return calc_grey_1.calcGrey; } });
exports.BLUE = (_a = {},
    _a['100'] = '#ECF2FF',
    _a['200'] = '#D6E3FF',
    _a['300'] = '#BDD2FF',
    _a['400'] = '#578DFF',
    _a['500'] = '#175FFF',
    _a['600'] = '#1043B2',
    _a['700'] = '#0034A3',
    _a);
exports.BLUE.DEFAULT = exports.BLUE['500'];
exports.RED = (_b = {},
    _b['100'] = '#FFF2F2',
    _b['200'] = '#FFD3D3',
    _b['300'] = '#FF5C5C',
    _b['400'] = '#FF4040',
    _b['500'] = '#EE0007',
    _b['600'] = '#DA0F15',
    _b['700'] = '#8F0005',
    _b);
exports.RED.DEFAULT = exports.RED['500'];
exports.GREEN = (_c = {},
    _c['100'] = '#E2F8ED',
    _c['200'] = '#C5F2DC',
    _c['300'] = '#5ACA93',
    _c['400'] = '#21BB6F',
    _c['500'] = '#0D9C56',
    _c['600'] = '#0A8046',
    _c);
exports.GREEN.DEFAULT = exports.GREEN['500'];
exports.ORANGE = (_d = {},
    _d['100'] = '#FEEFE7',
    _d['200'] = '#FCC7AA',
    _d['300'] = '#FAA475',
    _d['400'] = '#F88547',
    _d['500'] = '#F66A1F',
    _d['600'] = '#CA5010',
    _d);
exports.ORANGE.DEFAULT = exports.ORANGE['500'];
exports.YELLOW = (_e = {},
    _e['100'] = '#FFF2DD',
    _e['200'] = '#FFCC65',
    _e['300'] = '#FFAB00',
    _e['400'] = '#EF950D',
    _e['500'] = '#D68101',
    _e['600'] = '#AC5A0B',
    _e);
exports.YELLOW.DEFAULT = exports.YELLOW['400'];
exports.PURPLE = (_f = {},
    _f['100'] = '#F1E7FE',
    _f['200'] = '#D2AFFF',
    _f['300'] = '#B073FF',
    _f['400'] = '#9444FB',
    _f['500'] = '#7A1CF2',
    _f['600'] = '#6211CA',
    _f);
exports.PURPLE.DEFAULT = exports.PURPLE['500'];
exports.THEME = {
    PRIMARY: exports.BLUE['500'],
    SECONDARY: exports.BLUE['500'],
    TERTIARY: exports.BLUE['500'],
};
exports.THEME.DEFAULT = exports.THEME.PRIMARY;
var ACTION = exports.THEME.PRIMARY;
exports.UTILITY = {
    WARN: exports.YELLOW.DEFAULT,
    ACTION: ACTION,
    ERROR: exports.RED.DEFAULT,
    ERROR_INVERSE: exports.RED['200'],
    SUCCESS: exports.GREEN.DEFAULT,
    DEFAULT: ACTION,
};
exports.GREY_HUE = 226;
exports.GREY = (_g = {
        BLACK: '#000000',
        DARK: '#2C3242',
        MEDIUM: '#696E7C',
        LIGHT: '#E4E6EB',
        WHITE: '#FFFFFF'
    },
    _g['900'] = '#1B1F29',
    _g['800'] = '#2C3242',
    _g['700'] = '#4F5461',
    _g['600'] = '#696E7C',
    _g['500'] = '#8F94A2',
    _g['400'] = '#BDBFC7',
    _g['300'] = '#E4E6EB',
    _g['200'] = '#F1F2F5',
    _g['100'] = '#F7F8FA',
    _g);
exports.GREY.DEFAULT = exports.GREY.DARK;
exports.GRADIENT = {
    RIGHT: (0, calc_gradient_1.calcGradient)(270, 'rgba(255, 255, 255, 0)', '#E4E6EB'),
    LEFT: (0, calc_gradient_1.calcGradient)(270, '#E4E6EB', 'rgba(255, 255, 255, 0)'),
};
//# sourceMappingURL=index.js.map